<template>
  <div class="rule-answer-view-digital-item">
    <div class="rule-digital-name">
      <el-tooltip
        :disabled="ruleDigitalItem.ruleName.length <= 10"
        :content="ruleDigitalItem.ruleName"
        placement="top"
      >
        <span>{{ ruleTypeItemIndex+1 }}.{{ruleDigitalItemIndex+1}} {{ ruleDigitalItem.ruleName }}</span>
      </el-tooltip>
    </div>
    <div class="rule-digital-remark">
      {{ ruleDigitalItem.ruleRemark }}
      <template v-if="editAreaType === 'buyerfile'">
        <EbDownLoadFile
          :fileUrl="ruleDigitalItem.ruleContent[0]['url']"
          style="margin-top: -20px;"
        />
      </template>
      <template v-if="editAreaType === 'supplierfile'">
        <EbDownLoadFile :fileUrl="ruleDigitalItem.answerContent" style="margin-top: -20px;"/>
      </template>
      <div
        v-if="editAreaType === 'images'&&ruleDigitalItem.answerContent"
        class="rule-digital-view-images"
        :style="{backgroundImage:'url(' + realFileUrl + ')'}"
        v-image-preview
        :data-img-preview-src="realFileUrl"
      ></div>
    </div>
    <div class="rule-digital-view-area">
      <div v-if="editAreaType === 'buyerfile' || editAreaType === 'supplierfile'">&nbsp;</div>
      <div v-else-if="editAreaType === 'images'">
        {{ ruleDigitalItem.answerContent ? '&nbsp;' : '未上传' }}
        <!-- <div class="rule-digital-view-img-container" v-if="ruleDigitalItem.answerContent" >
        </div>
        <template v-else>未上传</template>-->
      </div>
      <div v-else>{{ ruleDigitalItem.answerContent }}</div>
    </div>
    <div class="rule-digital-aside">
      <template v-if="isCalcAside">
        <img :src="isAside ? '/static/img/zhizhen.jpg' : '/static/img/zhizhen-red.jpg'">&nbsp;
        <span>{{ isAside ? '无偏离' : '有偏离' }}</span>
      </template>
    </div>
  </div>
</template>
<script>
import { includes } from 'lodash';
import { baseURL } from '@/plugins/axios';
import EbDownLoadFile from '@/components/common/eb-download-file';
import { imagePreview } from '@/directives/image-preview';

export default {
  components: {
    EbDownLoadFile
  },
  directives: {
    imagePreview: imagePreview
  },
  filters: {},
  props: {
    ruleTypeItemIndex: {
      type: Number,
      required: true
    },
    ruleDigitalItem: {
      type: Object,
      required: true
    },
    ruleDigitalItemIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      user: this.$store.state.user.userInfo
    };
  },
  computed: {
    // 当前区域编辑类型
    editAreaType() {
      let ruleContent = this.ruleDigitalItem.ruleContent;
      return ruleContent[0].type;
    },
    // 当前规则是否计算偏离
    isCalcAside() {
      let ruleContent = this.ruleDigitalItem.ruleContent;
      return includes(['text', 'radio', 'radioText'], ruleContent[0].type);
    },
    // 是否偏离
    isAside() {
      return this.ruleDigitalItem.answerContent === this.ruleDigitalItem.ruleRemark;
    },
    realFileUrl() {
      return this.ruleDigitalItem.answerContent ? baseURL + this.ruleDigitalItem.answerContent : null;
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="less">
.rule-answer-view-digital-item {
  line-height: 55px;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: baseline; /*指定居中*/
  .rule-digital-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 165px;
    min-width: 165px;
    display: inline-block;
  }
  .rule-digital-remark {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 325px;
    min-width: 325px;
    display: inline-block;
  }
  .rule-digital-view-area {
    width: 300px;
  }
  .rule-digital-view-images {
    width: 200px;
    height: 200px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .rule-digital-aside {
    width: 130px;
    display: flex;
    display: -wekit-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
